import { useState } from "react";
import { useIntl } from "react-intl";

import styled from "styled-components";

import { CameraOutlined } from "@ant-design/icons";

import { Button, Tooltip } from "antd";

import { CmtAvatarModal } from "@app/components/users/field/CmtAvatarModal.tsx";
import { CmtUserAvatar } from "@app/components/users/field/CmtUserAvatar.tsx";
import { User } from "@app/models/User.ts";
import { colors } from "@app/theme.ts";

const StyledWrapper = styled.div`
  position: relative;
  display: inline-block;
  border: 4px solid ${colors.white};
  border-radius: 50%;
  box-shadow: 0 8px 24px -8px rgba(16, 16, 43, 0.35);
`;

const StyledEditButton = styled(Button)`
  position: absolute;
  right: 4px;
  bottom: 4px;
  border: 3px solid ${colors.white};
`;

interface CmtAvatarFieldProps {
  user: User;
  size: number;
}

export const CmtAvatarField = ({ user, size }: CmtAvatarFieldProps) => {
  const intl = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const label = intl.formatMessage({
    id: "collaborator.avatar.edit",
    defaultMessage: "Change avatar",
  });

  return (
    <>
      <StyledWrapper>
        <CmtUserAvatar user={user} size={size} />
        <Tooltip title={label}>
          <StyledEditButton
            type="primary"
            shape="circle"
            icon={<CameraOutlined />}
            aria-label={label}
            onClick={() => setOpenModal(true)}
          />
        </Tooltip>
      </StyledWrapper>
      <CmtAvatarModal
        open={openModal}
        handleCancel={() => setOpenModal(false)}
        user={user}
      />
    </>
  );
};
